export const ACTION_GET_CARDS = "ACTION_GET_CARDS";
export const ACTION_GET_TABLE = "ACTION_GET_TABLE";
export const ACTION_POST_SEND = "ACTION_POST_SEND";
export const ACTION_GET_PAYMENTMETHON_LIST = "ACTION_GET_PAYMENTMETHON_LIST";
export const ACTION_POST_PAYMENT_SUPPORT = "ACTION_POST_PAYMENT_SUPPORT";
export const ACTION_POST_CODE_CONFIRMATION_RESERVATION = "ACTION_POST_CODE_CONFIRMATION_RESERVATION";
export const ACTION_POST_CONFIRM_RESERVATION = "ACTION_POST_CONFIRM_RESERVATION";
export const ACTION_POST_RESEND_CODE_CONFIRMATION_RESERVATION = "ACTION_POST_RESEND_CODE_CONFIRMATION_RESERVATION";